<ng-template pub-comp-list></ng-template>